import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';

// Translate
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { locale as spanish } from './i18n/es';

// Model
import { Staff } from '../../../models/staff.model';
import { InventarioService } from 'app/main/empleados/empleados.service';

@Component({
    selector: 'app-empleados-edit',
    templateUrl: './empleados-edit.component.html',
    styleUrls: ['./empleados-edit.component.scss'],
    providers: [InventarioService]
})
export class EmpleadosEditComponent implements OnInit, OnDestroy
{
    public form: FormGroup;
    public dataStaff: Staff;
    private paramId: number;

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param _formBuilder
     * @param _fuseTranslationLoaderService
     * @param _route
     * @param _router
     * @param _empleadosService
     * @param _location
     * @param _matSnackBar
     */
    constructor(
        private _formBuilder: FormBuilder,
        private _fuseTranslationLoaderService: FuseTranslationLoaderService,
        private _route: ActivatedRoute,
        private _router: Router,
        private _empleadosService: InventarioService,
        private _location: Location,
        private _matSnackBar: MatSnackBar
    )
    {
        // Set the private defaults
        this._fuseTranslationLoaderService.loadTranslations(spanish);
        this._unsubscribeAll = new Subject();

        //Parametros
        this._route.params.subscribe((params: Params) => {
            this.paramId = params.id;
        });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------


    /**
     * On init
     */
    ngOnInit(): void {

        this.dataStaff = new Staff();
        this.form = this.createDataForm();

        //Obtiene el usuario
        this._empleadosService.getOne(this.paramId)
            .then((response: any) => {
                this.dataStaff = new Staff(response.data.staff);
                this.form = this.createDataForm();
            })
            .catch((error: any) => {
                this._matSnackBar.open('Problema con empleado', 'Error', {
                    verticalPosition: 'top',
                    duration        : 2000
                });

                this._router.navigate(['/empleados']);
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }


    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Create product form
     *
     * @returns {FormGroup}
     */
    createDataForm(): FormGroup
    {
        return this._formBuilder.group({
            id              : [this.dataStaff.id],
            name            : [this.dataStaff.name, [Validators.required]],
            job             : [this.dataStaff.job, [Validators.required]]
        });

    }

    saveEmpleado(): void {
        this._empleadosService.update(this.form.value)
            .then(() => {
                    this._matSnackBar.open('Empleado modificado', '', {
                        verticalPosition: 'top',
                        duration        : 2000
                    });

                    this._router.navigate(['/empleados']);
            })
            .catch((error: any) => {
                this._matSnackBar.open('Error en actualización', 'Error', {
                    verticalPosition: 'top',
                    duration        : 2000
                });
            });
    }
}
